const initialState = {
    sign_up_errors: {},
    sign_in_errors: {},
    user: null,
    authenticating: false,
    network_error: false,
    forgot_password_errors: {},
    forgot_password_message: null,
    reset_password_errors: {},
}

const onboardingKeys = [
    'onboarding_complete',
    'ica_complete',
    'personal_complete',
    'experience_complete',
    'crew_positions_complete',
    'gear_primary_complete',
    'gear_secondary_complete',
    'gear_tertiary_complete',

    // not directly related to onboarding but is necessary to calculate if onboarding is complete
    'crew_secondary_type_none',
    'crew_tertiary_type_none',
]

function handleOnboardingStepComplete(state, action) {
    // Take a copy of the current data
    const data = { ...state.user.crew }

    // Calculate the key for this onboarding step
    const onboardingStepKey = `${ action.step }_complete`

    // Set that key to true in the new data
    data[onboardingStepKey] = true

    // Now see whether the whole onboarding is complete
    data.onboarding_complete =
        data.ica_complete && data.personal_complete &&
        data.experience_complete && data.crew_positions_complete &&
        data.gear_primary_complete &&
        (data.crew_secondary_type_none === false ?
            data.gear_secondary_complete :
            true
        ) &&
        (data.crew_tertiary_type_none === false ?
            data.gear_tertiary_complete :
            true
        )

    return {
        ...state,
        user: {
            ...state.user,
            crew: data,
        },
    }
}

export default function account(state = initialState, action) {
    switch (action.type) {

        /*
         * Sign up
         */
        case 'SIGN_UP_SUCCESS':
            return {
                ...state,
                sign_up_errors: {},
            }
        case 'SIGN_UP_ERROR':
            return {
                ...state,
                sign_up_errors: action.errors || {},
            }

        /*
         * Sign in
         */
        case 'SIGN_IN_SUCCESS':
            return {
                ...state,
                user: action.data,
                sign_in_errors: {},
            }
        case 'SIGN_IN_ERROR':
            return {
                ...state,
                sign_in_errors: action.errors || {},
            }

        /*
         * Sign out
         */
        case 'SIGN_OUT':
            return {
                ...state,
                user: null,
            }

        /*
         * Activate
         */
        case 'ACTIVATE_SUCCESS':
            return {
                ...state,
                activation: action.data.message,
            }
        case 'ACTIVATE_ERROR':
            return {
                ...state,
                activation: action.errors.message,
            }

        /*
         * Authenticate
         */

        case 'AUTHENTICATE':
            return {
                ...state,
                authenticating: true,
            }
        case 'AUTHENTICATE_SUCCESS':
            return {
                ...state,
                user: action.data,
                authenticating: false,
            }
        case 'AUTHENTICATE_ERROR':
            return {
                ...state,
                user: null,
                authenticating: false,
            }

        // On network error, clear state and just set network error to true.
        case 'NETWORK_ERROR':
            return {
                ...state,
                network_error: true,
            }

        // The following actions are related to updating the `account.user.crew.*_complete`
        // variables when they are changed by incoming data.
        case 'LOAD_PERSONAL_SUCCESS':
        case 'SUBMIT_PERSONAL_SUCCESS':
            return {
                ...state,
                user: {
                    ...state.user,
                    crew: {
                        ...state.user.crew,
                        ...Object.keys(action.data).filter((key) => onboardingKeys.includes(key)).reduce(
                            (acc, key) => {
                                acc[key] = action.data[key]
                                return acc
                            },
                            {}
                        ),
                    },
                },
            }

        case 'ONBOARDING_STEP_COMPLETE':
            return handleOnboardingStepComplete(state, action)

        /*
         * Forgot password
         */

        case 'FORGOT_PASSWORD_SUCCESS':
            return {
                ...state,
                forgot_password_message: action.data.message,
                forgot_password_errors: {},
            }
        case 'FORGOT_PASSWORD_ERROR':
            return {
                ...state,
                forgot_password_errors: action.errors || {},
            }
        case 'FORGOT_PASSWORD_TRY_AGAIN':
            return {
                ...state,
                forgot_password_message: null,
                forgot_password_errors: {},
            }

        /*
         * Validate reset password token
         */

        case 'VALIDATE_RESET_TOKEN_SUCCESS':
            return {
                ...state,
                validation: action.data.message,
            }
        case 'VALIDATE_RESET_TOKEN_ERROR':
            return {
                ...state,
                validation: action.errors.message,
            }

        /*
         * Set password
         */

        case 'SET_PASSWORD_SUCCESS':
            return {
                ...state,
                set_password: action.data.message,
                reset_password_errors: {},
            }
        case 'SET_PASSWORD_ERROR':
            return {
                ...state,
                reset_password_errors: action.errors || {},
            }

        /*
         * Handle successful ICA signing
         */
        case 'SUBMIT_ICA_SUCCESS':
            return {
                ...state,
                user: {
                    ...state.user,
                    contract: action.data,
                },
            }

        default:
            return state
    }
}



// WEBPACK FOOTER //
// ./app/reducers/account.js